/**
 * @fileoverview Product page module - variants selection and cart functionality
 * @requires ProductGallery
 * @fires product.variant.selected
 * @fires product.variant.confirmed
 * @fires product.cart.adding
 * @fires product.cart.added
 * @fires product.cart.error
 */
var ProductPage = (function() {
    "use strict";

    var config = null;
    var state = {
        selectedVariants: [],
        confirmedVariants: [],
        clicked: 0,
        needConfirm: true,
        applyChecks: 0
    };

    var loadConfig = function() {
        var el = document.getElementById('product-config');
        if (!el) {
            return false;
        }
        try {
            config = JSON.parse(el.textContent);
            return true;
        } catch (e) {
            console.error('ProductPage: invalid JSON config', e);
            return false;
        }
    };

    var emit = function(eventName, data) {
        var event = new CustomEvent(eventName, { detail: data, bubbles: true });
        document.dispatchEvent(event);
    };

    var priceViewIndex = function(text) {
        var s = '';
        text = String(text).replace(' ', '').replace(',', '.');
        var tint = parseInt(text, 10);
        if (text.indexOf('.') > 0) {
            s = text.substring(text.indexOf('.') + 1);
            if (s.length === 1) {
                s += '0';
            }
        } else {
            s = '00';
        }
        s = s.substring(0, 2);
        if (config && config.isZeroDecimalCurrency && s === '00') {
            return tint + '<sup>,-</sup>';
        }
        return tint + '<sup>,' + s + '</sup>';
    };

    var recalculate = function() {
        var variantsAddons = 0;
        document.querySelectorAll('.attribs input[type=checkbox]:checked').forEach(function(el) {
            var value = parseFloat(el.dataset.calculated) || 0;
            variantsAddons += value;
        });
        var newPrice = variantsAddons + config.mainPrice;
        newPrice = parseFloat(newPrice.toFixed(2));
        var newPriceHtml = priceViewIndex(newPrice);
        document.querySelectorAll('.main_price_value').forEach(function(el) {
            el.innerHTML = newPriceHtml;
        });
        var priceWithVariants = document.querySelector('#myModalVariants .price-witch-variants');
        if (priceWithVariants) {
            priceWithVariants.style.visibility = 'visible';
            priceWithVariants.style.transition = 'opacity 0.3s';
            priceWithVariants.style.opacity = '1';
        }
    };

    var updateUrl = function(newPart) {
        var partsAfterP = window.location.pathname.split("p,")[1];
        if (!partsAfterP) return;
        var commaCount = (partsAfterP.match(/,/g) || []).length;
        var path = window.location.pathname;
        var updatePath = window.location.origin + '_path_' + window.location.search + window.location.hash;
        if (commaCount > 0) {
            var pathname = path.replace(/\d+(_\d+)?$/, newPart);
            updatePath = updatePath.replace('_path_', pathname);
        } else {
            updatePath = updatePath.replace('_path_', path + ',' + newPart);
        }
        history.replaceState(null, '', updatePath);
    };

    var getGaEvent = function(sku) {
        var variants = sku.split('_');
        var variantNameParts = [];
        variants.forEach(function(value) {
            var el = document.querySelector('[data-param_id="' + value + '"]');
            if (el) {
                var nameEl = el.parentElement.querySelector('.attrib_name');
                if (nameEl) {
                    variantNameParts.push(nameEl.innerHTML);
                }
            }
        });
        var variantName = variantNameParts.length ? ' - ' + variantNameParts.join(' ') : '';
        var mainPriceEl = document.querySelector('.main_price_value');
        var priceText = mainPriceEl ? mainPriceEl.textContent : '0';
        return {
            model: config.model + '_' + sku,
            name: config.nameLang + variantName,
            brand: config.brand,
            category: config.category,
            price: parseFloat(priceText),
            currency: config.currency,
            quantity: 1
        };
    };

    var applyCheck = function(id, cat) {
        state.clicked++;
        var obj = { id: id, cat: cat };

        state.selectedVariants = state.selectedVariants.filter(function(item) {
            return item.cat !== cat;
        });

        var existIdCat = state.selectedVariants.some(function(element) {
            return element.id === obj.id && element.cat === obj.cat;
        });

        var cId = document.querySelector('.c_' + id);

        if (!existIdCat) {
            state.applyChecks++;
            state.selectedVariants.push(obj);
        }

        if (cId) {
            var needConfirmParent = cId.closest('.need-confirm');
            if (needConfirmParent && !existIdCat) {
                state.confirmedVariants = state.confirmedVariants.filter(function(item) {
                    return item.cat !== cat;
                });
                state.confirmedVariants.push(obj);
            }
        }

        if (config.groupNum === state.confirmedVariants.length) {
            state.needConfirm = false;
        }

        if (state.clicked > config.groupNum) {
            state.needConfirm = false;
        }

        if (state.applyChecks > config.groupNum) {
            state.applyChecks = config.groupNum;
        }

        document.querySelectorAll('.c_' + cat + ' .active').forEach(function(el) {
            el.classList.remove('variant-activated');
            el.style.display = 'none';
        });
        if (cId) {
            cId.classList.add('variant-activated');
            cId.style.display = '';
        }
        document.querySelectorAll('.param_' + cat).forEach(function(el) {
            el.checked = false;
        });
        var paramEl = document.getElementById('param-' + id);
        if (paramEl) {
            paramEl.checked = true;
        }

        recalculate();

        emit('product.variant.selected', {
            id: id,
            cat: cat,
            selectedVariants: state.selectedVariants.slice()
        });

        if (config.groupNum === state.selectedVariants.length) {
            var sortedVariants = state.selectedVariants.slice().sort(function(a, b) {
                return a.id - b.id;
            });
            var sku = sortedVariants.map(function(item) {
                return item.id;
            }).join('_');

            var quoteBoxParent = document.querySelector('#col_gallery .row .col-12.mb-3');
            var gtin = config.gtins[sku];

            updateUrl(sku);

            if (state.clicked > config.groupNum) {
                var variantData = getGaEvent(sku);
                emit('product.variant.confirmed', {
                    sku: sku,
                    gtin: gtin,
                    variantData: variantData,
                    selectedVariants: state.selectedVariants.slice()
                });
            }

            if (quoteBoxParent) {
                var oldGtin = quoteBoxParent.querySelector('#gtin');
                if (oldGtin) oldGtin.remove();
                var gtinDiv = document.createElement('div');
                gtinDiv.className = 'quoteBox';
                gtinDiv.id = 'gtin';
                gtinDiv.innerHTML = '<article><p class="mb-0"><strong>GTIN: <span>' + gtin + '</span></strong></p></article>';
                quoteBoxParent.appendChild(gtinDiv);
            }

            updateGalleryImages(sku);
        }
    };

    var updateGalleryImages = function(sku) {
        var elements = [];
        var skus = document.querySelectorAll('[data-skus]');
        skus.forEach(function(element) {
            var elementSkus = String(element.dataset.skus);
            var arraySkus = elementSkus.split(',');
            if (arraySkus.length > 0 && arraySkus.indexOf(sku) > -1) {
                elements.push(element);
            }
        });

        if (elements.length > 0) {
            skus.forEach(function(element) {
                var found = false;
                var elementSkus = String(element.dataset.skus);
                var isSharedPhoto = elementSkus === '' || elementSkus === 'undefined';
                elements.forEach(function(elem) {
                    if (element.isEqualNode(elem)) {
                        found = true;
                    }
                });
                if (found || isSharedPhoto) {
                    element.parentElement.style.display = '';
                } else {
                    element.parentElement.style.display = 'none';
                }
            });

            if (typeof ProductGallery !== 'undefined') {
                ProductGallery.invalidateCache();
                setTimeout(function() {
                    ProductGallery.reset(sku);
                }, 50);
            }
        }
    };

    var machine = function(num, precision) {
        if (typeof precision === 'undefined') precision = 2;
        num = String(num).replace(",", ".").replace(/\s/g, "").replace(/[^0-9.\-]/g, '');
        return precision === null ? parseFloat(num) : parseFloat(num).toFixed(precision);
    };

    var formatNumber = function(num, precision, decimalSeparator, thousandsSeparator) {
        var parts = num.toString().split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);
        return parts.join(decimalSeparator);
    };

    var num2front = function(opt, precision, lang) {
        if (typeof precision === 'undefined') precision = 2;
        if (typeof lang === 'undefined') lang = config.lang;
        var sepType;

        switch (lang) {
            case 'pl':
            case 'fr':
            case 'de':
                sepType = [',', ' '];
                break;
            case 'cz':
                precision = 0;
                sepType = [',', ' '];
                break;
            case 'it':
            case 'en':
                sepType = ['.', ','];
                break;
            default:
                sepType = ['.', ' '];
                break;
        }

        var num = machine(opt, precision);
        return formatNumber(num, precision, sepType[0], sepType[1]);
    };

    var price = function(string) {
        var intPart = parseInt(string, 10);
        string = string.toString().replace(',', '.');
        var s;
        if (string.indexOf('.') === -1) {
            s = '00';
        } else {
            s = string.split('.')[1].substring(0, 2);
            s = (s.length === 1) ? s + '0' : s;
        }
        if (config && config.isZeroDecimalCurrency && s === '00') {
            return intPart + '<sup>,-</sup>';
        }
        return intPart + '<sup>,' + s + '</sup>';
    };

    var updateCartBadgeFromTotals = function(totals) {
        if (!totals) return;

        var count = NaN;
        if (typeof totals.total_items !== 'undefined') {
            count = parseInt(totals.total_items, 10);
        } else if (typeof totals.total_unique_items !== 'undefined') {
            count = parseInt(totals.total_unique_items, 10);
        }

        if (isNaN(count) && typeof totals.added_quantity !== 'undefined') {
            var current = document.querySelector('.basket_info .cart-item-num');
            var currentValue = current ? parseInt(current.textContent, 10) || 0 : 0;
            count = currentValue + parseInt(totals.added_quantity, 10);
        }

        document.querySelectorAll('.basket_info').forEach(function(container) {
            var badge = container.querySelector('.cart-item-num');
            if (!isNaN(count) && count > 0) {
                if (!badge) {
                    badge = document.createElement('span');
                    badge.className = 'cart-item-num';
                    container.appendChild(badge);
                }
                badge.textContent = count;
            } else if (badge) {
                badge.remove();
            }
        });
    };

    var addToCart = function(formData, buttonEl) {
        emit('product.cart.adding', { productId: config.productId, formData: formData });

        return fetch('cart-add,' + config.productId, {
            method: 'POST',
            body: JSON.stringify(formData)
        })
        .then(function(response) { return response.json(); })
        .then(function(response) {
            if (response.status === 'OK') {
                var cartItemData = response.data.data;
                showCartModal(cartItemData);

                buttonEl.classList.remove('adding-to-cart');
                buttonEl.removeAttribute('disabled');

                var badgeTotals = null;
                if (typeof response.totals !== 'undefined') {
                    badgeTotals = response.totals;
                } else if (cartItemData && typeof cartItemData.item_quantity !== 'undefined') {
                    badgeTotals = { added_quantity: parseInt(cartItemData.item_quantity, 10) || 1 };
                }

                if (badgeTotals) {
                    updateCartBadgeFromTotals(badgeTotals);
                    emit('product.cart.added', { response: response, totals: badgeTotals });
                    emit('cart.update', badgeTotals);
                }
            }
        })
        .catch(function(error) {
            console.error('ProductPage: cart error', error);
            emit('product.cart.error', { error: error });
            buttonEl.classList.remove('adding-to-cart');
            buttonEl.removeAttribute('disabled');
        });
    };

    var showCartModal = function(cartItemData) {
        var myModalCartAdd = new bootstrap.Modal('#myModalCartAdd');
        myModalCartAdd.show();

        var nameEl = document.querySelector('#myModalCartAdd .cart_item_product_info_name_lang');
        if (nameEl) nameEl.innerHTML = cartItemData._product_info.name_lang;

        var modelEl = document.querySelector('#myModalCartAdd .cart_item_model');
        if (modelEl) modelEl.innerHTML = cartItemData.model;

        if (typeof cartItemData._variant_info._variants_name_atom === 'object') {
            var paragraphs = '';
            Object.entries(cartItemData._variant_info._variants_name_atom).forEach(function(entry) {
                var key = entry[0];
                var value = entry[1];
                paragraphs += '<p class="text-black">' + key + ': <b><span>' + value + '</span></b></p>';
            });
            var variantInfoEl = document.querySelector('#myModalCartAdd .cart_item_variant_info');
            if (variantInfoEl) variantInfoEl.innerHTML = paragraphs;
        }

        var priceEl = document.querySelector('#myModalCartAdd .cart_item_item_price');
        if (priceEl) priceEl.innerHTML = price(cartItemData.item_price);

        var quantityEl = document.querySelector('#myModalCartAdd .cart_item_item_quantity');
        if (quantityEl) quantityEl.innerHTML = cartItemData.item_quantity;

        var src = config.urlBase + '/foto/products/mini/' + cartItemData._product_info.foto_lang + '?v=' + config.cacheFoto;
        var modalImg = document.querySelector('#myModalCartAdd .cart_item_product_info_foto_lang');

        if (modalImg) {
            var tempImg = new Image();
            tempImg.onload = function() {
                modalImg.src = src;
                modalImg.alt = cartItemData.model;
                modalImg.width = this.naturalWidth;
                modalImg.height = this.naturalHeight;
            };
            tempImg.onerror = function() {
                modalImg.src = src;
                modalImg.alt = cartItemData.model;
                modalImg.removeAttribute('width');
                modalImg.removeAttribute('height');
            };
            tempImg.src = src;
        }
    };

    var bindVariantEvents = function() {
        var seriesSelect = document.getElementById('jsSeries');
        if (seriesSelect) {
            seriesSelect.addEventListener('change', function() {
                document.location.href = this.value;
            });
        }

        document.querySelectorAll('.applyCheck').forEach(function(el) {
            el.addEventListener('click', function(e) {
                e.preventDefault();
                var attribs = this.closest('.attribs');
                if (attribs) {
                    attribs.querySelectorAll('.attrib .active').forEach(function(a) {
                        a.classList.remove('variant-activated');
                    });
                }
                applyCheck(this.dataset.param_id, this.dataset.cat_id);
            });
        });

        document.querySelectorAll('.applyCheckSelect').forEach(function(el) {
            el.addEventListener('change', function() {
                var selected = this.options[this.selectedIndex];
                applyCheck(selected.dataset.param_id, selected.dataset.cat_id);
            });
        });
    };

    var bindCartEvents = function() {
        var quoteBox = document.getElementById('quoteBoxOptions');
        var quoteBoxH4 = quoteBox ? quoteBox.querySelector('h4') : null;

        var addToCartBtn = document.getElementById('AddToCart');
        if (addToCartBtn) {
            addToCartBtn.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();

                if (state.needConfirm && state.confirmedVariants.length !== config.groupNum) {
                    if (quoteBox) {
                        quoteBox.classList.add('need-confirm');
                        quoteBox.style.border = '2px #b81900 solid';
                    }
                    if (quoteBoxH4) {
                        quoteBoxH4.innerHTML = config.translations.confirmVariant;
                        quoteBoxH4.style.cssText = 'color: #b81900; margin: 16px 0 0 12px !important;';
                    }

                    if (Math.min(window.screen.width, window.screen.height) < 768 && quoteBox) {
                        var quoteBoxRect = quoteBox.getBoundingClientRect();
                        var quoteBoxHeight = quoteBox.offsetHeight;
                        var quoteBoxTop = quoteBoxRect.top + window.scrollY;
                        window.scrollTo({ top: quoteBoxTop - quoteBoxHeight, behavior: 'smooth' });
                    }
                    return false;
                }

                var btn = this;
                btn.classList.add('adding-to-cart');
                btn.setAttribute('disabled', '');
                if (quoteBox) quoteBox.classList.remove('need-confirm');

                var cartForm = document.getElementById('cartAdd');
                var formDataJson = {};

                if (cartForm) {
                    var formData = new FormData(cartForm);
                    formData.forEach(function(value, key) {
                        var name = key;
                        if (name.indexOf('[') > -1) {
                            name = name.replace('[]', '');
                            if (typeof formDataJson[name] === 'undefined') {
                                formDataJson[name] = [];
                            }
                        }
                        if (typeof formDataJson[name] !== 'undefined' && Array.isArray(formDataJson[name])) {
                            formDataJson[name].push(value);
                        } else {
                            formDataJson[name] = value;
                        }
                    });
                }

                if (typeof VersanisDataLayer !== 'undefined') {
                    var qty = parseInt(formDataJson.item_number || 1);
                    VersanisDataLayer.ecommerce.addToCart({
                        model: config.model,
                        name: config.nameLang,
                        brand: config.brand,
                        category: config.category,
                        price: config.mainPrice,
                        currency: config.currency
                    }, qty);
                }

                addToCart(formDataJson, btn);
            });
        }

        if (quoteBox) {
            quoteBox.querySelectorAll('.attribs .attrib').forEach(function(el) {
                el.addEventListener('click', function() {
                    if (config.groupNum === state.confirmedVariants.length) {
                        quoteBox.style.border = '';
                        if (quoteBoxH4) {
                            quoteBoxH4.innerHTML = config.translations.selectVariant;
                            quoteBoxH4.style.cssText = '';
                        }
                        quoteBox.classList.remove('need-confirm');
                    }
                });
            });
        }
    };

    var initDefaults = function() {
        var groups = [];
        document.querySelectorAll('[data-cat_alias]').forEach(function(v) {
            groups.push(v.dataset.cat_alias);
        });

        var countOccurrences = groups.reduce(function(acc, value) {
            acc[value] = (acc[value] || 0) + 1;
            return acc;
        }, {});

        var autoConfirmedCats = {};
        Object.entries(countOccurrences).forEach(function(entry) {
            var key = entry[0];
            var value = entry[1];
            if (value === 1) {
                autoConfirmedCats[key] = true;
                state.confirmedVariants.push(key);
            }
        });

        if (config.firstVariant && config.firstVariant.length >= 2) {
            var catAlias = config.firstVariant[1];
            var variantsInCat = countOccurrences[catAlias] || 0;
            if (variantsInCat === 1) {
                applyCheck(config.firstVariant[0], config.firstVariant[1]);
            }
        }

        if (config.chosenVariants && config.chosenVariants.length > 0) {
            config.chosenVariants.forEach(function(v) {
                var paramEl = document.getElementById('param_' + v + '_label');
                if (paramEl) {
                    var catId = paramEl.dataset.cat_id;
                    applyCheck(String(v), catId);
                }
            });
        }

        var applyCheckSelect = document.querySelector('.applyCheckSelect');
        if (applyCheckSelect) {
            var selected = applyCheckSelect.options[applyCheckSelect.selectedIndex];
            applyCheck(selected.dataset.param_id, selected.dataset.cat_id);
        }

        if (state.selectedVariants.length === 0) {
            var cats = [];
            document.querySelectorAll('a[data-cat_id]').forEach(function(element) {
                var catId = element.dataset.cat_id;
                if (cats.indexOf(catId) === -1) {
                    cats.push(catId);
                }
            });
            cats.forEach(function(value) {
                var firstLink = document.querySelector('a[data-cat_id="' + value + '"]');
                if (firstLink) firstLink.click();
            });
        }

        document.querySelectorAll('.attrib .active').forEach(function(el) {
            el.classList.remove('variant-activated');
            el.style.background = '';
        });
        Object.keys(autoConfirmedCats).forEach(function(catAlias) {
            document.querySelectorAll('.c_' + catAlias + ' .active').forEach(function(el) {
                el.classList.add('variant-activated');
            });
        });

        if (config.chosenVariants && config.chosenVariants.length === config.groupNum) {
            var sortedChosen = config.chosenVariants.slice().sort(function(a, b) { return a - b; });
            var sku = sortedChosen.join('_');
            updateGalleryImages(sku);
        }

        if (typeof window.blinkElement === 'function') {
            document.querySelectorAll('.strikethrough').forEach(function(el) {
                window.blinkElement(el, 3, 800);
            });
        }
    };

    var initStickyAddToCart = function() {
        var addToCartBtn = document.getElementById('AddToCart');
        if (!addToCartBtn) return;

        var isFixed = false;
        var wrapper = null;
        var originalParent = addToCartBtn.parentNode;
        var originalNext = addToCartBtn.nextSibling;

        var applyFixed = function() {
            if (isFixed) return;
            isFixed = true;

            wrapper = document.createElement('div');
            wrapper.style.cssText = 'position:fixed;bottom:0;left:0;right:0;padding:0.75rem 1rem 0.85rem;z-index:997;background:linear-gradient(to top,#fff 0%,#fff 60%,rgba(255,255,255,0.95) 75%,rgba(255,255,255,0.7) 90%,rgba(255,255,255,0) 100%);box-shadow:0 -12px 32px rgba(0,0,0,0.08)';

            addToCartBtn.setAttribute('form', 'cartAdd');
            addToCartBtn.classList.remove('h-100');
            addToCartBtn.style.boxShadow = '0 4px 16px rgba(184,25,0,0.25)';

            wrapper.appendChild(addToCartBtn);
            document.body.appendChild(wrapper);
            document.body.style.paddingBottom = '7rem';
        };

        var removeFixed = function() {
            if (!isFixed) return;
            isFixed = false;

            addToCartBtn.removeAttribute('form');
            addToCartBtn.classList.add('h-100');
            addToCartBtn.style.boxShadow = '';

            originalParent.insertBefore(addToCartBtn, originalNext);

            if (wrapper && wrapper.parentNode) wrapper.parentNode.removeChild(wrapper);
            wrapper = null;
            document.body.style.paddingBottom = '';
        };

        var onResize = function() {
            if (window.innerWidth < 767) {
                applyFixed();
            } else {
                removeFixed();
            }
        };

        onResize();
        window.addEventListener('resize', onResize);
    };

    var init = function() {
        if (!loadConfig()) return;

        bindVariantEvents();
        bindCartEvents();
        initDefaults();
        initStickyAddToCart();
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    return {
        getConfig: function() { return config; },
        getState: function() { return Object.assign({}, state); },
        applyCheck: applyCheck,
        addToCart: addToCart,
        updateCartBadge: updateCartBadgeFromTotals
    };

})();
